import React from 'react';
import Slider from 'react-slick';
import { jsx, css } from '@emotion/core';
import A from '../../../shared/Anchor/Anchor';
import SlickArrowCircle from '../../../shared/SlickArrow/SlickArrowCirclePrimary';
import SlickArrow from '../../../shared/SlickArrow/SlickArrow';

import './CircularCarouselBrands.scss';
import Arrow from '../../../shared/Icons/Arrow';
import Link from '../../../shared/Link/Link';
import SlickArrowCirclePrimary from '../../../shared/SlickArrow/SlickArrowCirclePrimary';
import SlickArrowCircleSecondary from '../../../shared/SlickArrow/SlickArrowCircleSecondary';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';

const CircularCarouselBrands = ({
  primaryColor,
  secondaryColor,
  circularCarouselImages,
  circularCarouselVersion,
  coloredBackgroundCircularCarousel,
  brandsCarouselTitle,
  sliderCircleArrowsBrands,
  containerVariants,
  ...props
}) => {
  const settings = {
    arrows: true,
    prevArrow:
      sliderCircleArrowsBrands === 1 && circularCarouselVersion === 1 ? (
        <SlickArrowCircleSecondary secondaryColor={secondaryColor} />
      ) : sliderCircleArrowsBrands === 1 && circularCarouselVersion === 2 ? (
        <SlickArrowCircleSecondary secondaryColor={secondaryColor} />
      ) : sliderCircleArrowsBrands === 0 ? (
        <SlickArrow />
      ) : sliderCircleArrowsBrands === 1 && circularCarouselVersion === 3 ? (
        <SlickArrowCircleSecondary secondaryColor={secondaryColor} />
      ) : null,
    nextArrow:
      sliderCircleArrowsBrands === 1 && circularCarouselVersion === 1 ? (
        <SlickArrowCircleSecondary secondaryColor={secondaryColor} />
      ) : sliderCircleArrowsBrands === 1 && circularCarouselVersion === 2 ? (
        <SlickArrowCircleSecondary secondaryColor={secondaryColor} />
      ) : sliderCircleArrowsBrands === 0 ? (
        <SlickArrow />
      ) : sliderCircleArrowsBrands === 1 && circularCarouselVersion === 3 ? (
        <SlickArrowCircleSecondary secondaryColor={secondaryColor} />
      ) : null,
    dots: false,
    customPaging: function(i) {
      return !!withThumbnails ? (
        <a />
      ) : (
        <button className="dot">{/* {i + 1} */}</button>
      );
    },

    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: false,
    speed: 500,
    slidesToShow: circularCarouselVersion === 1 ? 7 : 8,
    slidesToScroll: circularCarouselVersion === 1 ? 7 : 1,
    centerMode: true,
    centerPadding: '100px',
    infinite: true,
    responsive: [
      {
        breakpoint: 1300,
        settings: { slidesToShow: 4, slidesToScroll: 1 },
      },

      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          centerPadding: '10px',
        },
      },
      // { breakpoint: 768, settings: { slidesToShow: 4, slidesToScroll: 1 } },
      {
        breakpoint: 900,
        settings: { slidesToShow: 3, slidesToScroll: 1, centerPadding: '10px' },
      },
      {
        breakpoint: 400,
        settings: { slidesToShow: 2, slidesToScroll: 1, centerPadding: '10px' },
      },
      {
        breakpoint: 300,
        settings: { slidesToShow: 1, slidesToScroll: 1, centerPadding: '10px' },
      },
    ],
  };

  return (
    <div className="circular-carousel-brands">
      <div
        className={`container ${circularCarouselVersion === 1 &&
          'centered'} ${coloredBackgroundCircularCarousel === 1 &&
          'colored-bg'}`}
        css={containerVariants}
      >
        {!!brandsCarouselTitle && (
          <div className="title-container">
            <h2>{brandsCarouselTitle}</h2>
          </div>
        )}
        <Slider {...settings}>
          {circularCarouselImages &&
            circularCarouselImages
              .filter(item => !!item.publishFarmakom)
              .map(item => (
                <div className={`frame`}>
                  <Link to={'/brand/' + item.seoName}>
                    <ImageDispatcher
                      src={item.logoImage}
                      alt={`Logo relativo al brand ${item.seoName}`}
                      className="img-fluid"
                      style={{ width: '100%' }}
                    />
                  </Link>
                </div>
              ))}
        </Slider>
      </div>
    </div>
  );
};

export default CircularCarouselBrands;
//circularCarouselVersion 1: more centered, max 7 circles
//circularCarouselVersion 2: max 8 circles
